import {Container, ContainerSize, Form, Heading, Text} from "@rebootui";
import CodeSnippet from "../../../components/controls/CodeSnippet";
import CodePreview from "../../../components/controls/CodePreview";
import CodeHighlighter from "../../../components/controls/CodeHighlighter";


type ChecksRadiosPageProps = {}

const ChecksRadiosPage = ({ }: ChecksRadiosPageProps) => {
    return (
        <Container size={ContainerSize.Fluid}>
            {/* Checkboxes and radios */}
            <Heading el="h1" className="fw-semibold mb-3 ls-1">
                Checkboxes and radios
            </Heading>
            <Heading el="h2" className="fw-medium fs-3 mt-4 mb-3">
                Checkboxes
            </Heading>
            <CodeSnippet>
                <CodePreview>
                    <Form.Check
                        type="checkbox"
                        label="Default checkbox"
                        id="flexCheckDefault"
                    />
                    <Form.Check
                        type="checkbox"
                        label="Checked checkbox"
                        id="flexCheckChecked"
                        defaultChecked
                    />
                </CodePreview>
                <CodeHighlighter language="tsx">
                    {checkboxesCode}
                </CodeHighlighter>
            </CodeSnippet>

            <Heading el="h2" className="fw-medium fs-3 mt-5 mb-3">
                Radios
            </Heading>
            <CodeSnippet>
                <CodePreview>
                    <Form.Check
                        type="radio"
                        label="Default radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault1"
                    />
                    <Form.Check
                        type="radio"
                        label="Default checked radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault2"
                        defaultChecked
                    />
                </CodePreview>
                <CodeHighlighter language="tsx">
                    {radiosCode}
                </CodeHighlighter>
            </CodeSnippet>

            <Heading el="h2" className="fw-medium fs-3 mt-5 mb-3">
                Switches
            </Heading>
            <Text className="mb-4">
                A switch has the markup of a custom checkbox but uses the <Text el="code">type="switch"</Text> to render a toggle switch.
            </Text>
            <CodeSnippet>
                <CodePreview>
                    <Form.Check
                        type="switch"
                        label="Default switch checkbox input"
                        id="flexSwitchCheckDefault"
                    />
                    <Form.Check
                        type="switch"
                        label="Checked switch checkbox input"
                        id="flexSwitchCheckChecked"
                        defaultChecked
                    />
                    <Form.Check
                        type="switch"
                        label="Disabled switch checkbox input"
                        id="flexSwitchCheckDisabled"
                        disabled
                    />
                </CodePreview>
                <CodeHighlighter language="tsx">
                    {switchesCode}
                </CodeHighlighter>
            </CodeSnippet>

            <Heading el="h2" className="fw-medium fs-3 mt-5 mb-3">
                Inline
            </Heading>
            <Text className="mb-4">
                Group checkboxes or radios on the same horizontal row by adding <Text el="code">inline</Text>.
            </Text>
            <CodeSnippet>
                <CodePreview>
                    <Form.Check
                        inline
                        type="checkbox"
                        label="1"
                        id="inlineCheckbox1"
                        value="option1"
                    />
                    <Form.Check
                        inline
                        type="checkbox"
                        label="2"
                        id="inlineCheckbox2"
                        value="option2"
                    />
                    <Form.Check
                        inline
                        type="checkbox"
                        label="3 (disabled)"
                        id="inlineCheckbox3"
                        value="option3"
                        disabled
                    />
                </CodePreview>
                <CodeHighlighter language="tsx">
                    {inlineCode}
                </CodeHighlighter>
            </CodeSnippet>
        </Container>
    )
}


const checkboxesCode = `<Form.Check
  type="checkbox"
  label="Default checkbox"
  id="flexCheckDefault"
/>
<Form.Check
  type="checkbox"
  label="Checked checkbox"
  id="flexCheckChecked"
  defaultChecked
/>`;

const radiosCode = `<Form.Check
  type="radio"
  label="Default radio"
  name="flexRadioDefault"
  id="flexRadioDefault1"
/>
<Form.Check
  type="radio"
  label="Default checked radio"
  name="flexRadioDefault"
  id="flexRadioDefault2"
  defaultChecked
/>`;

const switchesCode = `<Form.Check
  type="switch"
  label="Default switch checkbox input"
  id="flexSwitchCheckDefault"
/>
<Form.Check
  type="switch"
  label="Checked switch checkbox input"
  id="flexSwitchCheckChecked"
  defaultChecked
/>
<Form.Check
  type="switch"
  label="Disabled switch checkbox input"
  id="flexSwitchCheckDisabled"
  disabled
/>`;

const inlineCode = `<Form.Check
  inline
  type="checkbox"
  label="1"
  id="inlineCheckbox1"
  value="option1"
/>
<Form.Check
  inline
  type="checkbox"
  label="2"
  id="inlineCheckbox2"
  value="option2"
/>
<Form.Check
  inline
  type="checkbox"
  label="3 (disabled)"
  id="inlineCheckbox3"
  value="option3"
  disabled
/>`;

export default ChecksRadiosPage;
